var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 20C40 31.0457 31.0457 40 20 40C8.9543 40 0 31.0457 0 20C0 8.9543 8.9543 0 20 0C31.0457 0 40 8.9543 40 20ZM29.4617 16.4882C29.4617 16.3007 29.4617 16.115 29.4485 15.9292C30.3182 15.3171 31.0699 14.5595 31.6667 13.6898C30.856 14.0399 29.9951 14.2693 29.114 14.3703C30.0418 13.8302 30.7363 12.9801 31.0681 11.9794C30.1949 12.4827 29.2408 12.838 28.2452 13.0289C26.5623 11.2885 23.7464 11.2046 21.9561 12.8414C20.8012 13.8969 20.3118 15.4704 20.6701 16.9719C17.0955 16.7981 13.7656 15.1562 11.5087 12.4553C10.3292 14.4311 10.9313 16.9582 12.8845 18.2277C12.1768 18.2072 11.4849 18.0214 10.867 17.6867V17.7415C10.867 19.7995 12.359 21.5715 14.4328 21.979C13.7788 22.1528 13.0922 22.1784 12.4259 22.0535C13.0086 23.8144 14.6766 25.0206 16.5788 25.0557C15.0041 26.2584 13.0597 26.9116 11.058 26.9099C10.7042 26.909 10.3512 26.8885 10 26.8474C12.0333 28.1161 14.3985 28.7889 16.8138 28.7855V28.7889C24.9902 28.7889 29.4617 22.2007 29.4617 16.4882Z",
    fill: "#006AED"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.0f4b822d453181d05e02597dbc3dc66c.svg";
export { ForwardRef as ReactComponent };